export default __webpack_public_path__ + "53430a5305a24554fb61517792a6812a.jpeg";